import { useCallback } from 'react'
import useRootTranslations from 'src/hooks/useTranslations'

/**
 * Wraps the translations under an MFE name for easy scoping and preventing scope collisions
 * This is only useful for react microfrontends, which is okay for now.
 * @param {string} mfeName
 * @returns {function(namespace: string, componentName: string): {t: (*|(function(*, *): *)), namespace: *, i18n: *}|{t: (*|(function(*, *): *)), namespace, i18n: (*|i18n)}}
 */
export default function useMfeTranslations(mfeName) {
    return useCallback(
        function useTranslations(namespace, componentName) {
            return useRootTranslations(`${mfeName}_${namespace}`, componentName)
        },
        [mfeName]
    )
}
